import React from 'react';

interface IFilterIcon{
  className?:any
}

const FilterIcon = ({ className }:IFilterIcon) => (

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_2280_52350)">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 5.83333C2 5.3731 2.3731 5 2.83333 5H21.1667C21.6269 5 22 5.3731 22 5.83333C22 6.29357 21.6269 6.66667 21.1667 6.66667H2.83333C2.3731 6.66667 2 6.29357 2 5.83333ZM5.33333 11.6667C5.33333 11.2064 5.70643 10.8333 6.16667 10.8333H17.8333C18.2936 10.8333 18.6667 11.2064 18.6667 11.6667C18.6667 12.1269 18.2936 12.5 17.8333 12.5H6.16667C5.70643 12.5 5.33333 12.1269 5.33333 11.6667ZM8.66667 17.5C8.66667 17.0398 9.03976 16.6667 9.5 16.6667H14.5C14.9602 16.6667 15.3333 17.0398 15.3333 17.5C15.3333 17.9602 14.9602 18.3333 14.5 18.3333H9.5C9.03976 18.3333 8.66667 17.9602 8.66667 17.5Z" fill="black" className={className} />
    </g>
    <defs>
      <clipPath id="clip0_2280_52350" className={className}>
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

export default FilterIcon;
